export default "__VITE_ASSET__D3oxUlCF__"